/**
 * 取引先一覧検索条件VOクラス
 *
 * @export KYMW0400InputModel
 * @class KYMW0400InputModel
 */
export class KYMW0400InputModel {

  /**
   * 呼出元区分(0：発注先取引先、1：支払先取引先)
   */
  public supplierFlg: string = <string>'';

  /**
   * 複数選択モード(true: チェックボックス表示)
   */
  public isMultiCheckable: boolean = false;

  /**
   * 複数選択モード時チェック済項目
   */
  public multiSuppliers?: Supplier[];
}

export class Supplier {
  /** 取引先コード */
  public supplierCode: string = null;
  /** 取引先名 */
  public supplierNameKanji: string = null;
}